import React from 'react';
import { Modal, Input } from 'antd';
import { changeReasonError } from '../../../utils/labelTrace';

export default function ChangeReasonDialog({ open, reason, onChange, onCancel, onSave, busy, error, number }) {
  return <Modal open={open} title="填写修改原因" onCancel={onCancel}
    onOk={onSave} okText="确认更新" cancelText="取消" confirmLoading={busy}
    okButtonProps={{ disabled: !!changeReasonError(reason) }} cancelButtonProps={{ disabled: busy }}
    closable={!busy} maskClosable={false} keyboard={!busy} destroyOnClose>
    <p>标签编号：{number || '—'}</p>
    <p style={{color:'#64748b'}}>本次修改原因将随标签保存，可在“我的创建”中查看。</p>
    <label htmlFor="label-change-reason">修改原因 <span style={{color:'#dc2626'}}>*</span></label>
    <Input.TextArea id="label-change-reason" autoFocus value={reason} onChange={e => onChange(e.target.value)}
      rows={4} maxLength={500} showCount disabled={busy}
      placeholder="例如：更新产品配料表，补充最新检测报告" style={{marginTop:8,marginBottom:20}} />
    {error && <p role="alert" style={{color:'#b42318'}}>{error}</p>}
  </Modal>;
}
